import { render, staticRenderFns } from "./Abilities.vue?vue&type=template&id=4b260044&"
import script from "./Abilities.vue?vue&type=script&lang=js&"
export * from "./Abilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports